import request from '@/utils/request2';
/**获取账号列表数据 */
export function userList(data) {
  return request.post('admin/user/list', data);
}
export function accountDetail(data) {
  return request.post('admin/user/list', data);
}
/**账号操作 */
export function accountOperation(data) {
  let url = data.userId ? 'admin/user/edit' : 'admin/user/store';
  return request.post(url, data);
}
/**保单列表获取标签 */
export function getTags(data) {
  return request.post('/admin/policy/getTags', data);
}
/**
 * @description 删除当前列
 * @param {string}  id
 * @returns {}
 */

export function deleteTable(data) {
  return request.post('admin/user/delete', data);
}

/**账号修改状态 */
export function accountStatus(data) {
  return request.post('admin/user/status', data);
}

//修改是否强制上传投保告知书状态
export function changeUploadMandatoryStatus(data) {
  return request.post('admin/user/insurance-notice/upload-mandatory', data);
}
//配置投保告知书模板
export function configInsuranceNoticeTemplate(data) {
  return request.post('admin/user/insurance-notice/config', data);
}

//客户投保告知书列表资源
export function insuranceNoticeListResource(data) {
  return request.post('admin/notice-template/template-resource', data);
}
//已经配置的投保告知书模板列表
export function insuranceNoticeConfigList(data) {
  return request.post('admin/user/insurance-notice/config-resource', data);
}

//投保告知书上传情况下载
export function downloadBackNoticeTemplateInfo(data) {
  return request.post('admin/user/insurance-notice/download', data, 'download');
}